import { render, staticRenderFns } from "./lrRich.vue?vue&type=template&id=7e3dfe5a&scoped=true&"
import script from "./lrRich.vue?vue&type=script&lang=js&"
export * from "./lrRich.vue?vue&type=script&lang=js&"
import style0 from "./lrRich.vue?vue&type=style&index=0&id=7e3dfe5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3dfe5a",
  null
  
)

export default component.exports